//ABB新增页面
export default [
  {
    // ABB风格首页
    path: '/newHome',
    name: 'newHome',
    component: () => import('@/page/abbNewPage/newHome.vue')
  },
  //能源管理
  {
    // 建筑信息
    path: '/BuildingInfo',
    name: 'BuildingInfo',
    component: () => import('@/page/abbNewPage/BuildingInfo.vue')
  },
  {
    // 建筑类型
    path: '/BuildingType',
    name: 'BuildingType',
    component: () => import('@/page/abbNewPage/BuildingType.vue')
  },
  {
    // 能源区域
    path: '/EnergySubArea',
    name: 'EnergySubArea',
    component: () => import('@/page/abbNewPage/EnergySubArea.vue')
  },
  {
    // 能源类型
    path: '/EnergySubType',
    name: 'EnergySubType',
    component: () => import('@/page/abbNewPage/EnergySubType.vue')
  },
  {
    // 设备能源分项
    path: '/equipmented',
    name: 'equipmented',
    component: () => import('@/page/abbNewPage/equipmented.vue')
  },
  {
    // 区域变量
    path: '/energyArea',
    name: 'energyArea',
    component: () => import('@/page/abbNewPage/energyArea.vue')
  },
  {
    // 能耗排名
    path: '/ranking',
    name: 'ranking',
    component: () => import('@/page/abbNewPage/ranking.vue')
  },
  {
    // 负荷配置
    path: '/loadConfiguration',
    name: 'loadConfiguration',
    component: () => import('@/page/abbNewPage/loadConfiguration.vue')
  },
  {
    // 能耗配置
    path: '/energyConsumption',
    name: 'energyConsumption',
    component: () => import('@/page/abbNewPage/energyConsumption.vue')
  },
  {
    // 区域能耗
    path: '/regionCost',
    name: 'regionCost',
    component: () => import('@/page/abbNewPage/energy/regionCost.vue')
  },
  {
    // 分项能耗
    path: '/subItemCost',
    name: 'subItemCost',
    component: () => import('@/page/abbNewPage/energy/subItemCost.vue')
  },
  {
    // 用电综览
    path: '/electricOverview',
    name: 'electricOverview',
    component: () => import('@/page/abbNewPage/energy/electricOverview.vue')
  },
  {
    // 用水综览
    path: '/waterOverview',
    name: 'waterOverview',
    component: () => import('@/page/abbNewPage/energy/waterOverview.vue')
  },
  {
    // 用气综览
    path: '/gasOverview',
    name: 'gasOverview',
    component: () => import('@/page/abbNewPage/energy/gasOverview.vue')
  },
  //尖峰平谷
  {
    // 统计看板
    path: '/EnterpriseBasicDatadata',
    name: 'EnterpriseBasicDatadata',
    component: () => import('@/page/abbNewPage/EnterpriseBasicDatadata.vue')
  },
  {
    // 费率模板
    path: '/rateTemplate',
    name: 'rateTemplate',
    component: () => import('@/page/abbNewPage/rateTemplate.vue')
  },
  {
    // 费率配置
    path: '/rateConfiguration',
    name: 'rateConfiguration',
    component: () => import('@/page/abbNewPage/rateConfiguration.vue')
  },
  //报表模块
  {
    // 日报表
    path: '/dayReport',
    name: 'dayReport',
    component: () => import('@/page/abbNewPage/reportPage/dayReport.vue')
  },
  {
    // 年报表
    path: '/generate',
    name: 'generate',
    component: () => import('@/page/abbNewPage/reportPage/generate.vue')
  },
  {
    // 周报表
    path: '/weekReport',
    name: 'weekReport',
    component: () => import('@/page/abbNewPage/reportPage/weekReport.vue')
  },
  {
    //能流图（新）
    path: '/EnergyFlow',
    name: 'EnergyFlow',
    component: () =>
      import('@/page/abbNewPage/EnergyFlow.vue')
  },
  {
    //能流图综览（新）
    path: '/EnergyFlowKanBan',
    name: '/EnergyFlowKanBan',
    component: () =>
      import('@/page/abbNewPage/EnergyFlowKanBan.vue')
    // import('@/page/energyFlow/energyFlowConfig.vue')
    // import('@/page/yuexin/energyStream.vue')
  },
  {
    //菜单管理（新 暂不可用）
    path: '/AppModuleRight',
    name: 'AppModuleRight',
    component: () =>
      import('@/page/abbNewPage/AppModuleRight.vue')
    // import('@/page/menuConfig/webMenuConfig.vue')
    // import('@/page/menuConfig/appMenuConfig.vue')
  },
  {
    //应用类型
    path: '/applicationType',
    name: 'applicationType',
    component: () =>
      import('@/page/abbNewPage/applicationType.vue')
  },
  {
    //应用类型组
    path: '/typeGroup',
    name: 'typeGroup',
    component: () =>
      import('@/page/abbNewPage/typeGroup.vue')
  },
  {
    //越限管理
    path: '/overMedian',
    name: 'overMedian',
    component: () =>
      import('@/page/abbNewPage/overMedian.vue')
  },
  {
    //电子档案
    path: '/elArchives',
    name: 'elArchives',
    component: () => import('@/page/abbNewPage/elArchives.vue')
  },
  {
    //测试
    path: '/watcher',
    name: 'watcher',
    // component: () => import('@/page/projectDingZhi/Ubiquitous/UbiquitousOverview.vue')
    component: () => import('@/page/abbNewPage/watcher.vue')
  },
  {
    //泵站运行报告
    path: '/runReport',
    name: 'runReport',
    component: () => import('@/page/abbNewPage/runReport.vue')
  },
  {
    //logo配置
    path: '/logoConfiguration',
    name: 'logoConfiguration',
    component: () => import('@/page/abbNewPage/logoConfiguration.vue')
  },
  {
    //损耗临界值配置
    path: '/lossThreshold',
    name: 'lossThreshold',
    component: () => import('@/page/abbNewPage/lossThreshold.vue')
  },
  //以下是ViFa产出能耗分析
  {
    //映射管理
    path: '/mapping',
    name: 'mapping',
    component: () => import('@/page/vifa/mapping.vue')
  },
  {
    //产能分析
    path: '/produceAnalyse',
    name: 'produceAnalyse',
    component: () => import('@/page/vifa/produceAnalyse.vue')
  },
  {
    //产量管理
    path: '/outputRule',
    name: 'outputRule',
    component: () => import('@/page/vifa/outputRule.vue')
  },
  {
    //区域配置(企业，厂房，工序)
    path: '/areaOutfit',
    name: 'areaOutfit',
    component: () => import('@/page/vifa/areaOutfit.vue')
  },
  {
    //查看配置与排名
    path: '/allocateRanking',
    name: 'allocateRanking',
    component: () => import('@/page/vifa/allocateRanking.vue')
  },
  {
    //产量管理
    path: '/yieldManagement',
    name: 'yieldManagement',
    component: () => import('@/page/vifa/yieldManagement.vue')
  },
  {
    //产能稼动率
    path: '/production',
    name: 'production',
    component: () => import('@/page/vifa/production.vue')
  },

  {
    //设备值
    path: '/deviceValue',
    name: 'deviceValue',
    component: () =>
      import('@/page/rtvalue/deviceValue.vue')
  },

  //光伏系统
  {
    //发电效率
    path: '/eleEfficiency',
    name: 'eleEfficiency',
    component: () =>
      import('@/page/guangfu/eleEfficiency.vue')
  },{
    //发电统计
    path: '/elestatistics',
    name: 'elestatistics',
    component: () =>
      import('@/page/guangfu/elestatistics.vue')
  },{
    //收益统计
    path: '/income',
    name: 'income',
    component: () =>
      import('@/page/guangfu/income.vue')
  },{
    //收益分析
    path: '/incomeAnalysis',
    name: 'incomeAnalysis',
    component: () =>
      import('@/page/guangfu/incomeAnalysis.vue')
  },{
    //效率分析
    path: '/efficiencyAnalysis',
    name: 'efficiencyAnalysis',
    component: () =>
      import('@/page/guangfu/efficiencyAnalysis.vue')
  },{
    //效率平谷
    path: '/assessment',
    name: 'assessment',
    component: () =>
      import('@/page/guangfu/assessment.vue')
  },{
    //设备清洗
    path: '/decclean',
    name: 'decclean',
    component: () =>
      import('@/page/guangfu/decclean.vue')
  },{
    //系统看板
    path: '/gfbulletin',
    name: 'gfbulletin',
    component: () =>
      import('@/page/guangfu/gfbulletin.vue')
  },{
    //逆变器
    path: '/inverter',
    name: 'inverter',
    component: () =>
      import('@/page/guangfu/inverter.vue')
  },{
    //并网柜
    path: '/cabinet',
    name: 'cabinet',
    component: () =>
      import('@/page/guangfu/cabinet.vue')
  },{
    //箱变
    path: '/boxTransformer',
    name: 'boxTransformer',
    component: () =>
      import('@/page/guangfu/boxTransformer.vue')
  },{
    //汇流箱
    path: '/confluence',
    name: 'confluence',
    component: () =>
      import('@/page/guangfu/confluence.vue')
  },{
    //气象站
    path: '/weatherStation',
    name: 'weatherStation',
    component: () =>
      import('@/page/guangfu/weatherStation.vue')
  },
  
  {
    // 日志记录
    path: '/mylogging',
    name: 'mylogging',
    component: () => import('@/page/abbNewPage/mylogging.vue')
  },
  {
    // 遥控配置
    path: '/remoteControl',
    name: 'remoteControl',
    component: () => import('@/page/abbNewPage/remoteControl.vue')
  },
  {
    // 设备遥控配置
    path: '/newdeviceControl',
    name: 'newdeviceControl',
    component: () => import('@/page/abbNewPage/newdeviceControl.vue')
  },
  {
    // 设备遥控日志
    path: '/remoteControlLog',
    name: 'remoteControlLog',
    component: () => import('@/page/abbNewPage/remoteControlLog.vue')
  },

  {
    //短信发送
    path: '/textMessage',
    name: 'textMessage',
    component: () =>
      import('@/page/abbNewPage/textMessage.vue')
  },
]
